import { Controller } from "@hotwired/stimulus"

// Learner timeline block (TMS-912): swaps the panel below the track as the
// learner picks a stage. The track is an ARIA tab list, so only the selected
// stage is in the tab order and the arrow keys move between them.
export default class extends Controller {
  static targets = ["stage", "panel"]

  selectStage(event) {
    event.preventDefault()

    const index = Number(event.currentTarget.dataset.stageIndex)
    if (Number.isNaN(index)) return

    this.showStage(index)
  }

  navigateOnArrowKeys(event) {
    const step = this.arrowKeyStep(event.key)
    if (step === null) return

    event.preventDefault()

    const currentIndex = Number(event.currentTarget.dataset.stageIndex)
    const count = this.stageTargets.length
    const nextIndex = this.nextStageIndex(event.key, currentIndex, step, count)

    this.showStage(nextIndex)
    this.stageFor(nextIndex)?.focus()
  }

  arrowKeyStep(key) {
    if (key === "ArrowRight" || key === "ArrowDown") return 1
    if (key === "ArrowLeft" || key === "ArrowUp") return -1
    if (key === "Home" || key === "End") return 0

    return null
  }

  nextStageIndex(key, currentIndex, step, count) {
    if (key === "Home") return 0
    if (key === "End") return count - 1

    return (currentIndex + step + count) % count
  }

  showStage(index) {
    this.stageTargets.forEach((stage) => {
      const selected = Number(stage.dataset.stageIndex) === index
      stage.classList.toggle("is-selected", selected)
      stage.setAttribute("aria-selected", selected ? "true" : "false")
      stage.tabIndex = selected ? 0 : -1
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = Number(panel.dataset.stageIndex) !== index
    })
  }

  stageFor(index) {
    return this.stageTargets.find((stage) => Number(stage.dataset.stageIndex) === index)
  }
}
